import {
  SELLER_CENTER_LOADING_REQUEST,
  GET_SELLER_CENTER_USERS,
} from "../constants/Constants";

let initialState = {
  sellerCenterUsers: [],
  sellerCenterLoading: false,
};

export const SellerCenterReducer = (state = initialState, action) => {
  switch (action.type) {
    case SELLER_CENTER_LOADING_REQUEST:
      return { ...state, sellerCenterLoading: action.payload };

    case GET_SELLER_CENTER_USERS:
      return { ...state, sellerCenterUsers: action.payload };

    default:
      return state;
  }
};